import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

( function( app ) {
  const COMPONENT = {
    splides: [],
    rows: [],

    init() {
      this.rows = Array.from(
          document.querySelectorAll( '.treatment-planner-cta__splide' ),
      );

      if ( !this.rows.length ) return;

      this.update = this.update.bind( this );
      this.update();
      window.addEventListener( 'resize', this.update );
    },

    update() {
      const isDesktop = window.matchMedia( '(min-width: 1024px)' ).matches;
      const visibleRows = isDesktop ? 4 : 5;

      this.destroy();

      this.rows.forEach( ( row ) => {
        const rowIndex = Number( row.dataset.row );
        const rowColor = row.dataset.rowColor;

        if ( rowIndex < visibleRows ) {
          row.style.display = '';

          row.style.setProperty( '--row-color', rowColor );

          row.offsetHeight;

          const splide = new Splide( row, {
            type: 'loop',
            drag: 'free',
            gap: '24px',
            arrows: false,
            autoWidth: true,
            pagination: false,
            direction: rowIndex % 2 === 0 ? 'ltr' : 'rtl',
            autoScroll: {
              speed: 0.50,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );

          splide.mount( {AutoScroll} );
          this.splides.push( splide );
        } else {
          row.style.display = 'none';
        }
      } );
    },

    destroy() {
      this.splides.forEach( ( splide ) => {
        if ( splide && !splide.state.is( Splide.STATES.DESTROYED ) ) {
          splide.destroy( true );
        }
      } );
      this.splides = [];
    },
  };

  app.registerComponent( 'treatment-planner-cta', COMPONENT );
} )( app );
